import { SuggestPendingDelegatorCount } from '@oh-vcp/components-common';
import { useQuery } from 'react-query';
import apiService from './apiService';

const fetchAllSuggestUpdates = async (): Promise<SuggestPendingDelegatorCount[]> => {
  const response = await apiService.get('/profiles/suggest/people/delegator');
  if (!response || !response.data) return [];
  return response.data;
};

const useAllSuggestUpdates = (isEnabled: boolean) => {
  return useQuery({
    enabled: isEnabled,
    queryFn: () => fetchAllSuggestUpdates(),
    queryKey: ['useAllSuggestUpdates'],
    retry: 0
  });
};

export default useAllSuggestUpdates;
